@use "@fukuri-admins/ui/layout" as *;

.PageHeader {
  display: flex;
  align-items: center;
  border-bottom: 1px solid border('Tertiary');
  background: white;

  &--title {
    padding: spacing('20') spacing('24');
  }

  &--breadcrumb {
    padding: spacing('16') spacing('24');
  }
}

.PageHeader__Title {
  font-size: 20px;
  font-weight: 500;
  color: text('High');
  letter-spacing: 0.04em;
  line-height: 1.5;
}
